import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=cf639e96&"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js&"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports